import React, { ReactNode } from "react";

export function getCookieValue(key: string) {
  if (typeof window !== "undefined") {
    return document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${key}=`))
      ?.split("=")[1];
  }
}

export function focusAndScrollToDiv(targetId) {
  const targetDiv = document.getElementById(targetId);
  if (targetDiv) {
    targetDiv.scrollIntoView({
      behavior: "smooth", // Optional: 'auto' for instant scroll
      block: "start", // Optional: 'center', 'end', or 'nearest'
    });
    // To also set focus programmatically, the div must be focusable.
    // Add tabindex="-1" to the div in HTML to allow this.
    targetDiv.focus();
  }
}

export function renderRequiredLabel(label: ReactNode) {
  return React.createElement(
    React.Fragment,
    null,
    label,
    React.createElement("span", { className: "text-red-500" }, " *"),
  );
}
